import { Controller } from "@hotwired/stimulus"

// Controls the two-step checkout modal: a product list step and a
// "Final Book-Check" step shown for print books before continuing to checkout.
export default class extends Controller<HTMLElement> {
  static targets = ["dialog", "listPanel", "finalPanel", "continueButton"]

  declare readonly dialogTarget: HTMLElement
  declare readonly listPanelTarget: HTMLElement
  declare readonly finalPanelTarget: HTMLElement
  declare readonly continueButtonTarget: HTMLAnchorElement

  static values = {
    wideClass: { type: String, default: "final-check-wide" },
  }
  declare wideClassValue: string

  showFinalCheck(event: Event & { params: { url?: string } }) {
    event.preventDefault()
    if (event.params.url) {
      this.continueButtonTarget.href = event.params.url
    }

    this.listPanelTarget.classList.add("hidden")
    this.finalPanelTarget.classList.remove("hidden")
    this.dialogTarget.classList.add(this.wideClassValue)
  }

  back() {
    this.finalPanelTarget.classList.add("hidden")
    this.listPanelTarget.classList.remove("hidden")
    this.dialogTarget.classList.remove(this.wideClassValue)
  }
}
